import Swiper from "swiper";
import {Navigation, Pagination} from "swiper/modules";
import {MD_WIDTH, LG_WIDTH, XL_WIDTH} from "@main/helpers/const";

/** Класс слайдера с навигацией и пагинацией. */
class Slider {
    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} el Элемент.
     */
    constructor(el) {
        this.el = el;
        this.swiperNode = this.el.querySelector(".js-mch-slider");
        this.nextArrow = this.el.querySelector(".js-mch-slider-nav-next");
        this.prevArrow = this.el.querySelector(".js-mch-slider-nav-prev");
        this.pagination = this.el.querySelector(".js-mch-slider-pagination");

        this.createSlider();
        new ResizeObserver(this.addToSliderStyleOverflow.bind(this)).observe(
            document.body
        );
    }

    /**
     * Инициализация слайдера.
     *
     * @returns {void}
     */
    createSlider() {
        new Swiper(this.swiperNode, {
            modules: [Navigation, Pagination],
            slidesPerView:
                Number(this.swiperNode.dataset.slidePerView) || "auto",
            clickable: true,
            slideToClickedSlide: false,
            spaceBetween: Number(this.swiperNode.dataset.slideSpace) || 8,
            loop: false || this.swiperNode.dataset.sliderLoop,
            navigation: {
                nextEl: this.nextArrow,
                prevEl: this.prevArrow,
            },
            pagination: {
                el: this.pagination,
                clickable: true,
            },
            breakpoints: {
                [MD_WIDTH]: {
                    slidesPerView:
                        Number(this.swiperNode.dataset.mdSlidePerView) ||
                        "auto",
                    spaceBetween:
                        Number(this.swiperNode.dataset.mdSlideSpace) || 16,
                },
                [LG_WIDTH]: {
                    slidesPerView:
                        Number(this.swiperNode.dataset.lgSlidePerView) ||
                        "auto",
                    spaceBetween:
                        Number(this.swiperNode.dataset.lgSlideSpace) || 16,
                },
                [XL_WIDTH]: {
                    slidesPerView:
                        Number(this.swiperNode.dataset.xlSlidePerView) ||
                        "auto",
                    spaceBetween:
                        Number(this.swiperNode.dataset.lgSlideSpace) || 16,
                },
            },
        });
    }

    /**
     * Изменение свойства overflow при изменение размера вьюпорта.
     * Отслеживается размер вьюпорта и значение, передаваемое в data-атрубут
     * data-slide-per-view, data-md-slide-per-view, data-lg-slide-per-view -
     * количество слайдов, видимые одновременно в контейнере слайдера.
     * По умолчанию, slidePerView: "auto".
     *
     * @returns {void}
     */
    addToSliderStyleOverflow([entry]) {
        const slidePerView = this.swiperNode.dataset.slidePerView;
        const mdSlidePerView = this.swiperNode.dataset.mdSlidePerView;
        const lgSlidePerView = this.swiperNode.dataset.lgSlidePerView;

        const isMobile = entry.contentRect.width < MD_WIDTH;
        const isTablet =
            entry.contentRect.width >= MD_WIDTH && window.innerWidth < LG_WIDTH;
        const isDesktop = entry.contentRect.width >= LG_WIDTH;

        if (isMobile && slidePerView && !!Number(slidePerView)) {
            this.swiperNode.style.overflow = "hidden";
        } else if (isTablet && mdSlidePerView && !!Number(mdSlidePerView)) {
            this.swiperNode.style.overflow = "hidden";
        } else if (isDesktop && lgSlidePerView && !!Number(lgSlidePerView)) {
            this.swiperNode.style.overflow = "hidden";
        } else {
            this.swiperNode.style.overflow = "visible";
        }
    }
}

document
    .querySelectorAll(".js-mch-slider-block")
    .forEach((slider) => new Slider(slider));